export const ADMIN_PATH = "admin";
export const ADMIN_PRONOSTICSV2_PATH = "pronosticsv2"; // PRONOSTICSV2_PATH
export const ADMIN_BINGO_PATH = "bingo";
export const ADMIN_BINGO_TEMPLATES_PATH = "templates";
export const ADMIN_BINGO_GAMES_PATH = "bingogames";
export const ADMIN_CLICK_AND_COLLECTS_PATH = "clickandcollects";
export const ADMIN_CROSSBARS_PATH = "crossbars";
export const ADMIN_GAMES_PATH = "games";
export const ADMIN_EVENTS_PATH = "events";
export const ADMIN_PRONOSTICS_PATH = "pronostics";
export const ADMIN_QUIZZES_PATH = "quizzes";
export const ADMIN_WALLS_PATH = "walls";
export const ADMIN_WORKFORCES_PATH = "workforces";
export const CLICK_AND_COLLECT_PATH = "clickandcollect";
export const CROSSBAR_PATH = "crossbar";
export const EVENT_PATH = "event";
export const GAME_PATH = "game";
export const LOGIN_PATH = "login";
export const MAN_OF_THE_MATCH_PATH = "motm";
export const PRONOSTIC_PATH = "prono";
export const QUIZ_PATH = "quiz";
export const SCREEN_PATH = "screen";
export const SCREEN_CARROUSEL_PATH = "carrousel";
export const SCREEN_CAST_PATH = "cast";
export const SCREEN_SHOW_QR_CODE_PATH = "showqr";
export const WALL_PATH = "wall";
export const BINGO_SCREEN_PATH = "bingoscreen";
export const BINGO_GAME_PATH = "bingogame";
export const ADMIN_HTML_PAGE_PATH = "htmlpageadmin";
export const HTML_PAGE_PATH = "htmlpage";
export const ADMIN_PLACES_PATH = "placeadmin";
export const PRONOSTICSV2_PATH = "pronosticsv2";
export const FOODMENU_V2_PATH = "foodmenuv2";
export const ADMIN_CHAMPIONSHIPS_PATH = "championships";
export const ADMIN_SONOMETER_PATH = "sonometer";
export const SONOMETER_PATH = "sonometer";
export const SONOMETER_SCREEN_PATH = "sonometerscreen";
